import { message } from 'antd';
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWith409 from './baseQueryWith409';
import qs from 'qs';
import fetch from 'auth/FetchInterceptor';

// direct fetch without RTK Query
export const getComunas = query =>
	fetch.get(
		`/comunas${
			query
				? `?${qs.stringify(
						{ ...query, publicationState: 'live' },
						{
							encodeValuesOnly: true,
						}
				  )}`
				: ''
		}`
	);
export const getComuna = ({ id, query }) =>
	fetch.get(`/comunas/${id}${
		query
			? `?${qs.stringify(
					{ ...query, publicationState: 'live' },
					{
						encodeValuesOnly: true,
					}
			  )}`
			: ''
	}
`);
export const addComuna = data => fetch.post('/comunas', data);
export const updateComuna = ({ id, ...data }) =>
	fetch.put(`/comunas/${id}`, data);
export const deleteComuna = id => fetch.delete(`/comunas/${id}`);

// RTK Query
export const comunasApi = createApi({
	reducerPath: 'comunasApi',
	baseQuery: baseQueryWith409,

	// default configuration
	refetchOnReconnect: true,
	refetchOnMountOrArgChange: true,
	refetchOnFocus: true,

	//endpoints
	endpoints: build => ({
		getComunas: build.query({
			query: query => {
				return {
					url: `/comunas${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: result =>
				// is result available?
				result
					? // successful query
					  [
							...result.map(({ id }) => ({ type: 'Comunas', id })),
							{ type: 'Comunas', id: 'LIST' },
					  ]
					: // an error occurred, but we still want to refetch this query when `{ type: 'Posts', id: 'LIST' }` is invalidated
					  [{ type: 'Comunas', id: 'LIST' }],
		}),
		getComuna: build.query({
			query: ({ id, query }) => {
				return {
					url: `/comunas/${id}
					${
						query
							? `?${qs.stringify(
									{ ...query, publicationState: 'live' },
									{
										encodeValuesOnly: true,
									}
							  )}`
							: ''
					}
					`,
					method: 'GET',
				};
			},
			transformResponse: response => response.data,
			providesTags: (result, error, id) => [{ type: 'Comunas', id }],
		}),
		addComuna: build.mutation({
			query: data => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/comunas`,
					method: 'POST',
					body: JSON.stringify({
						data: {
							...data,
							created_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Comuna agregado exitosamente');
				} catch (error) {
					message.error('Error al agregar comuna');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: [{ type: 'Comunas', id: 'LIST' }],
		}),
		updateComuna: build.mutation({
			query: ({ id, ...data }) => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/comunas/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							...data,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Comuna actualizado exitosamente');
				} catch (error) {
					message.error('Error al actualizar comuna');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, { id }) => [{ type: 'Comunas', id }],
		}),
		deleteComuna: build.mutation({
			query: id => {
				const user = JSON.parse(localStorage.getItem('me'));
				return {
					url: `/comunas/${id}`,
					method: 'PUT',
					body: JSON.stringify({
						data: {
							publishedAt: null,
							updated_by_user: user.id,
						},
					}),
				};
			},
			onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
				// try catch with antd message when fulfilled and rejected
				try {
					await queryFulfilled;
					message.success('Comuna eliminado exitosamente');
				} catch (error) {
					message.error('Error al eliminar comuna');
					if (error.error.data?.error) {
						message.error(error.error.data?.error.message);
					}
				}
			},
			invalidatesTags: (result, error, id) => [{ type: 'Comunas', id }],
		}),
	}),
});

export const {
	useGetComunasQuery,
	useGetComunaQuery,
	useAddComunaMutation,
	useUpdateComunaMutation,
	useDeleteComunaMutation,
} = comunasApi;
